import Icon from '../components/Icon.vue'

Icon.register({
  'kiss-wink-heart': {
    width: 504,
    height: 512,
    paths: [
      {
        d: 'M501.1 402.5c9.2 23.9-4.4 49.4-28.5 55.7l-83 21.5c-5.4 1.4-10.9-1.8-12.4-7.1l-22.9-82.6c-6.6-24 8.8-48.6 34-52.6 22-3.5 43.1 11.6 49 33l2.3 8.4 8.4-2.2c21.6-5.6 45.1 5.1 53.1 25.9zM323.5 398.5c0 0 23.6 83.9 23.9 84.6-30.5 13.4-64 20.9-99.4 20.9-137 0-248-111-248-248s111-248 248-248 248 111 248 248c0 31.8-6.2 62.1-17.1 90-6-1.5-12.2-2.8-18.6-2.9-29.1-49.8-98.1-50.6-127.8-4.3-11.3 17.7-14.6 39.4-9 59.7zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM288 396c0-13-13.4-27.3-35.2-36.4 21.8-8.7 35.2-23 35.2-36 0-19.2-28.7-41.5-71.5-44-8.2-1.2-12.4 11.7-3.6 15.4l17 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.8 21.5l-17 7.2c-5.7 2.5-6 12.3 0 14.8l17 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.8 21.5l-17 7.2c-8.5 3.6-4.9 16.2 3.6 15.4 42.8-2.5 71.5-24.8 71.5-44zM304 217l9.7-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.5 21.5 0.3 19.8-10.8-4-25.2-34.2-42.1-59.9-42.1-25.7 0-55.9 16.9-59.9 42.1-1.8 11.2 11.5 18.2 19.8 10.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiss-wink-heart.js
// module id = 1502
// module chunks = 0